const getImageSource = (image?: string) => {
  if (image?.startsWith('data:image')) {
    return image;
  }
  return `data:image/png;base64, ${image?.replace(/-/g, '+').replace(/_/g, '/')}`;
};

export default getImageSource;
